import { Stack } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { DataTitle } from '../DataTitle';
import { NavigateTo } from '../NavigateTo';

interface IBankInformation {
  bankInfo: {
    bankName: string;
    branchCode: string;
    branchName: string;
    accountNum: string;
  };
}

export const BankInformation = ({ bankInfo }: IBankInformation) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.PersonalDetails);

  const dataTitles = [
    { title: dictionary.bankInformation.bankName, data: bankInfo.bankName },
    { title: dictionary.bankInformation.branch, data: bankInfo.branchName },
    {
      title: dictionary.bankInformation.accountNumber,
      data: bankInfo.accountNum,
    },
  ];

  const isDesktop = useIsDesktop();

  return (
    <Stack gap={'24px'}>
      <Stack
        direction={'row'}
        gap={isDesktop ? '40px' : '20px 10px'}
        flexWrap={'wrap'}
      >
        {dataTitles.map((dataTitle, index) => (
          <Stack minWidth={'136px'} key={index} width={'auto'}>
            <DataTitle dataTitle={dataTitle.title} data={dataTitle.data} />
          </Stack>
        ))}
      </Stack>
      <NavigateTo
        href='/requests/update-bank-details/8/19'
        label={dictionary.links.updateBankDetails}
      />
    </Stack>
  );
};
